import layoutStore from 'storeUtils/layoutStore';
import mainStore from 'storeUtils/mainStore';
import { pageNeedsReloading } from 'storeUtils/storeUtils';

import { fetchJSON } from 'utils/fetchJSON';

export default function mealConfirm(needRebalance, keepOriginal, date, person_id, meal_id, personMeal, personMealIdToReplace) {
    if (layoutStore.request.progress) return;
    layoutStore.request.progress = true;

    return fetchJSON('/api/meal/confirm', {
        needRebalance,
        keepOriginal,
        date,
        person_id,
        meal_id,
        personMeal,
        baseInfoTimeUTC: mainStore.baseInfoTimeUTC,
        personMealIdToReplace,
    })
        .then((json) => {
            layoutStore.request.progress = false;
            mainStore.baseInfoTimeUTC = json?.request?.newUTCTime;

            if (json.request?.error) {
                pageNeedsReloading();
            }
            return json;
        })
        .catch(error => {
            console.log('[api/meal/completeMeal.js] Error: ', error);
            layoutStore.request.progress = false;
            return undefined;
        });
}
